import { Component, computed, inject, input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfigurationWaterfall } from '../configuration-waterfall.service';
import { Environment, editorMeta } from '../configuration-view';

@Component({
  selector: 'app-environment-meta',
  styleUrl: './environment-meta.scss',
  template: `@if (meta(); as item) {<span class="editor-meta">@if (item.name) {<span class="editor-name" [style.background]="item.color">{{ item.name }}</span>}@if (item.ago) {<span class="editor-when">{{ item.ago }}</span>}</span>}`,
})
export class EnvironmentMeta {
  private readonly transloco = inject(TranslocoService);
  readonly row = input.required<ConfigurationWaterfall>();
  readonly environment = input.required<Environment>();
  readonly meta = computed(() => editorMeta(this.row(), this.environment(), this.transloco.activeLang()));
}
